module.exports = __webpack_public_path__ + "static/images/business-storefront.f445dcfde2a575ea492d6f3abe406ee9.svg";